import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  AuthProvider,
  type TAuthConfig,
  type TRefreshTokenExpiredEvent,
} from 'react-oauth2-code-pkce';
import App from './App';

const authConfig: TAuthConfig = {
  clientId: (import.meta as any).env?.VITE_OAUTH_CLIENT_ID || 'Tkv2ZdzNLHqphKNcfNIN',
  authorizationEndpoint:
    (import.meta as any).env?.VITE_OAUTH_AUTH_URL ||
    'https://auth-appdev.sangoma.com/oauth/authorize',
  tokenEndpoint:
    (import.meta as any).env?.VITE_OAUTH_TOKEN_URL || 'https://auth-appdev.sangoma.com/oauth/token',
  logoutEndpoint:
    (import.meta as any).env?.VITE_OAUTH_LOGOUT_URL || 'https://auth-appdev.sangoma.com/sso/logout',
  redirectUri: window.location.origin,
  scope: 'openid',
  state: 'dummy',
  loginMethod: 'redirect',
  logoutMethod: 'redirect',
  extraLogoutParameters: {
    redirect_uri: window.location.origin,
    id_token_hint: 'none',
    post_logout_redirect_uri: 'none',
    token: 'none',
    token_type_hint: 'none',
  },
  defaultTokenExpiresIn: 3600,
  defaultRefreshTokenExpiresIn: 2592000,
  autoLogin: false,
  onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) => {
    console.log('[Auth] Refresh token expired - re-authentication required');
    return event.logIn(undefined, undefined, 'redirect');
  },
};

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider authConfig={authConfig}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
);

